<div class="container py-3 mb-5 mb-md-0">
  <div class="row justify-content-center">
    <div class="col-12 col-md-10 ">
      <div class="card shadow-sm border-0">
        <div class="card-body p-3 p-md-4">
          <div class="d-flex align-items-center gap-2 mb-3">
            <div class="rounded-3 d-flex align-items-center justify-content-center" style="width:48px;height:48px;background:#fde8ea;color:#e63946;">
              <i class="bi bi-person-vcard"></i>
            </div>
            <div class="flex-grow-1 min-w-0">
              <h2 class="h5 mb-1 text-danger fw-bold text-truncate">KYC Verification</h2>
              <p class="text-muted small mb-0">Verify your identity by uploading the required documents</p>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-12 col-sm-6" *ngFor="let doc of documents">
              <div class="border rounded-3 p-3 h-100">
                <label class="form-label fw-semibold mb-1">{{ doc.label }} <span *ngIf="doc.required" class="text-danger">*</span></label>
                <div class="text-muted small mb-2">Accepted: JPG, PNG, PDF (max 1MB)</div>

                <div class="d-flex align-items-center gap-2">
                  <div class="flex-grow-1">
                    <input type="file"
                           class="form-control form-control-sm"
                           accept="image/*,.pdf"
                           (change)="onNativeFileSelect($event, doc.type)">
                  </div>
                  <button type="button" class="btn btn-outline-secondary btn-sm"
                          (click)="onFileRemove(doc.type)" [disabled]="!doc.uploaded">
                    Remove
                  </button>
                </div>

                <div *ngIf="doc.uploaded" class="d-flex align-items-center text-success mt-2 small">
                  <i class="bi bi-check-circle me-1"></i>
                  Uploaded
                </div>
              </div>
            </div>
          </div>

          <!-- Partner payout details -->
          <div class="mt-4">
            <h5 class="mb-2 text-danger">Payout Details</h5>
            <div class="row g-3">
              <div class="col-12">
                <label class="form-label">UPI ID</label>
                <input type="text" class="form-control" placeholder="yourname@hdfcbank" [(ngModel)]="upiId">
                <div class="form-text">Optional. Example: {{'yourname@hdfcbank'}}</div>
              </div>
              <div class="col-12">
                <div class="alert alert-info py-2 mb-0 small">Alternatively, provide your bank account details below.</div>
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-label">Bank Name</label>
                <select class="form-select" [(ngModel)]="bank.bankName">
                  <option value="" disabled selected>Select bank</option>
                  <option *ngFor="let name of indianBanks" [ngValue]="name">{{name}}</option>
                </select>
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-label">Account Holder Name</label>
                <input type="text" class="form-control" [(ngModel)]="bank.accountHolderName" placeholder="Full name as per bank">
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-label">IFSC</label>
                <input type="text" class="form-control" [(ngModel)]="bank.ifsc" placeholder="e.g., HDFC0001234">
              </div>
              <div class="col-12 col-sm-6">
                <label class="form-label">Account Number</label>
                <input type="text" class="form-control" [(ngModel)]="bank.accountNumber" placeholder="Account number">
              </div>

            </div>
          </div>

          <div *ngIf="submissionInProgress" class="mt-3">
            <div class="progress" style="height: 8px;">
              <div class="progress-bar bg-danger" role="progressbar" [style.width]="progressValue + '%'"
                   aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <p class="text-muted small text-center mt-2 mb-0">Submitting documents for verification...</p>
          </div>

          <div class="mt-3">
            <button type="button" class="btn btn-danger w-100 fw-bold"
                    (click)="submitForVerification()" [disabled]="submissionInProgress">
              Submit for Verification
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
